import {createSinglePathSVG} from './TEMPLATE'

export const Carousel_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M18 7v10h2V7h-2ZM4 17h2V7H4v10ZM8 5v14h8V5H8Zm12 0a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2h2Z',
})
